import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { findDOMNode } from 'react-dom';
import classnames from 'classnames';
import noop from '../noop';
import InfoTooltip from './info-tooltip';
import Icon from './icon';

class TextInput extends Component {
  static displayName = 'TextInput';
  static propTypes = {
    validation: PropTypes.shape({
      message: PropTypes.string,
      status: PropTypes.oneOf(['error', 'success', 'none', 'loading'])
    }),
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    className: PropTypes.string,
    showValidationTooltip: PropTypes.bool,
    type: PropTypes.string,
    value: PropTypes.string,
    maxLength: PropTypes.number,
    onEnterPress: PropTypes.func,
    onKeyPress: PropTypes.func,
    onKeyDown: PropTypes.func,
    size: PropTypes.oneOf(['giant', 'large', 'regular', 'small']),
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    autoFocus: PropTypes.bool,
    showImmediateTooltip: PropTypes.bool,
    name: PropTypes.string,
    showCharCounter: PropTypes.bool
  };
  static defaultProps = {
    validation: {
      status: 'none',
      message: null
    },
    onChange: noop,
    maxLength: 0,
    placeholder: '',
    showValidationTooltip: false,
    type: 'text',
    value: null,
    size: 'large',
    disabled: false,
    readOnly: false,
    autoFocus: false,
    showImmediateTooltip: false,
    name: '',
    showCharCounter: false
  };
  constructor(props, context) {
    super(props, context);
    this.state = { inputFocus: false };
  }

  UNSAFE_componentWillUpdate(nextProps) {
    var validation = this.props.validation;
    var hasValidationTooltip = validation.status !== 'none' && !!validation.message;

    var nextValidation = nextProps.validation;
    var willHaveValidationTooltip = nextValidation.status !== 'none' && !!nextValidation.message;

    if (hasValidationTooltip && !willHaveValidationTooltip && this.refs.infoTooltip) {
      this.refs.infoTooltip.hide();
    }
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.focus();
      // this.onFocus();
    }
  }

  componentDidUpdate() {
    if (this.props.showValidationTooltip && this.refs.infoTooltip) {
      if (this.state.inputFocus || this.props.showImmediateTooltip) {
        this.refs.infoTooltip.show();
      } else {
        this.refs.infoTooltip.hide();
      }
    }
  }

  focus() {
    if (this.refs.inputField) {
      this.refs.inputField.focus();
    }
  }

  selectAll() {
    if (this.refs.inputField) {
      let node = this.refs.inputField;
      node.setSelectionRange(0, node.value.length);
    }
  }

  handleChange(event) {
    var name = event.target.name;
    var value = event.target.value;
    if (name) {
      this.props.onChange(value, name);
    } else {
      this.props.onChange(value);
    }
  }

  onFocus() {
    this.setState({ inputFocus: true }, () => {
      if (this.props.onFocus) {
        this.props.onFocus();
      }
    });
  }

  onBlur() {
    this.setState({ inputFocus: false }, () => {
      if (this.props.onBlur) {
        this.props.onBlur();
      }
    });
  }

  stopTooltipInfoClick(event) {
    event.stopPropagation();
  }

  renderTooltipMessage(message) {
    var tooltipInfo = null;
    if (message) {
      tooltipInfo = (
        <InfoTooltip
          ref="infoTooltip"
          alignElement={() => this.refs.infoTooltipAlign}
          direction="top"
        >
          <span className="text">{message}</span>
        </InfoTooltip>
      );
    }

    var status = this.props.validation.status,
      name = '';

    if (status.match(/success|error/)) {
      name = `validation-circle-${status}`;
    }

    return (
      <div className="icon-wrap" ref="infoTooltipAlign">
        <Icon name={name} />
        {tooltipInfo}
      </div>
    );
  }

  onKeyPress(event) {
    var ENTER = 13;
    if (event.charCode == ENTER && this.props.onEnterPress) {
      this.props.onEnterPress();
    } else if (this.props.onKeyPress) {
      this.props.onKeyPress(event);
    }
  }

  onKeyDown(event) {
    if (this.props.onKeyDown) {
      this.props.onKeyDown(event);
    }
  }

  render() {
    var inputClassNames = classnames('text-field-' + this.props.size, this.props.className, {
      error: this.props.validation.status === 'error',
      success: this.props.validation.status === 'success',
      loading: this.props.validation.status === 'loading'
    });

    var tooltipMessage = null;
    if (this.props.validation.status !== 'none' && this.props.showValidationTooltip) {
      tooltipMessage = this.renderTooltipMessage(this.props.validation.message);
    }

    var maxLength = this.props.maxLength ? this.props.maxLength : '';

    return (
      <div className={inputClassNames}>
        {tooltipMessage}
        <input
          ref="inputField"
          type={this.props.type}
          value={this.props.value}
          name={this.props.name}
          placeholder={this.props.placeholder}
          maxLength={maxLength}
          onChange={this.handleChange.bind(this)}
          onClick={this.stopTooltipInfoClick}
          onFocus={this.onFocus.bind(this)}
          onBlur={this.onBlur.bind(this)}
          readOnly={this.props.readOnly}
          onKeyPress={this.onKeyPress.bind(this)}
          onKeyDown={this.onKeyDown.bind(this)}
          disabled={this.props.disabled}
        />
        {this.props.showCharCounter && !!maxLength && (
          <div className={'char-counter'}>
            {(this.props.value && this.props.value.length) || 0} / {maxLength}
          </div>
        )}
      </div>
    );
  }
}

export default TextInput;
